import * as constants from './constants';

const colorsMapper = [
    '#ffc3fe',
    '#afbee1',
    '#9cd1a5',
    '#ff7e90',
    '#b4f4a0',
    '#81f1f5',
    '#ff936b',
    '#fcc466',
    '#35ddbf',
    '#b6a1de',
    '#5eda67',
    '#a7e569',
    '#63b8ff',
    '#66fa81',
    '#f48015',
    '#f29f83',
    '#d2f1cc',
    '#d386ff',
];

export function getColumnColor(columnIndex) {
    return colorsMapper[columnIndex];
}
